export { default } from './Zoom';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Zoom/index.js
// module id = 567
// module chunks = 2